export default __webpack_public_path__ + "static/media/old-seedj.c4b347b1.png";